import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';

import { IInput } from './input.interface';
import { IErrors } from './errors.interface';

import { ControlValueAccessor } from '../../../shared/interfaces/forms.setup';

export const INPUT_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(() => InputSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    providers: [
        INPUT_CUSTOM_INPUT_ACCESSOR
    ]
})

export class InputSharedComponent implements ControlValueAccessor {
    @Input() icon: string;
    @Input() iconSecondary: string;
    @Input() inputType = 'text';
    @Input() inputId = '';
    @Input() inputName = '';
    @Input() inputStyle: 'primary' | 'secondary' = 'primary';
    @Input() inputDisabled = false;
    @Input() placeholder = '';
    @Input() loading = false;

    @Input() input: IInput; // @todo to be removed
    @Input() errors: Array<IErrors> = [];
    // tslint:disable-next-line:no-input-rename
    @Input('value') _value = '';

    @Output() blur = new EventEmitter();
    @Output() focus = new EventEmitter();
    @Output() secondaryButtonClick = new EventEmitter();

    focused = false;
    onChange: any = () => {};
    onTouched: any = () => {};

    get value(): any { return this._value; }
    set value(val) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    registerOnChange(fn): void {
        this.onChange = fn;
    }

    writeValue(value): void {
        this.value = value;
    }

    registerOnTouched(fn): void {
        this.onTouched = fn;
    }

    updateValue(event: KeyboardEvent): void {
        this.value = (event.target as HTMLInputElement).value;
    }
}
